jQuery(document).ready(function($) {
    const $blocks = $('.wp-block-jormi-blocks-query-card');
    if ($blocks.length === 0) return;
    
    // Add CSS to prevent width calculations from causing flashing
    $('head').append(`
      <style>
        /* Force stable dimensions during initialization */
        .swiper-container-initializing,
        .swiper:not(.swiper-initialized) {
          visibility: hidden !important;
          max-width: 100% !important;
          width: 100% !important;
          overflow: hidden !important;
          position: relative !important;
        }
        
        /* Ensure slide widths are constrained */
        .swiper-slide {
          max-width: 100% !important;
          width: 100% !important;
        }
      </style>
    `);
    
    // Wait for DOM to be fully rendered before initializing Swiper
    setTimeout(function() {
      $blocks.each(function() {
        const $block = $(this);
        const variant = $block.attr('data-post');
        
        if (variant == 'room') {
          const $swiperContainer = $block.find('.swiper');
          
          if ($swiperContainer.length) {
            // Add class to help with CSS targeting
            $swiperContainer.addClass('swiper-container-initializing');
            
            // Force the container to have a stable width before initialization
            const containerWidth = $swiperContainer.parent().width();
            $swiperContainer.css({
              'width': containerWidth + 'px',
              'max-width': '100%'
            });
            
            // Initialize swiper with minimal config
            const swiper = new Swiper($swiperContainer[0], {
              // Core settings
              slidesPerView: 1,
              spaceBetween: 16,
              
              // Prevent any automatic dimension calculations
              autoHeight: false,
              
              // Wait for images if any
              preloadImages: true,
              updateOnImagesReady: true,
              
              // Force hardware acceleration to reduce flickering
              hardware: true,
              
              // Navigation
              navigation: {
                prevEl: $block.find('.swiper-button-prev')[0], 
                nextEl: $block.find('.swiper-button-next')[0]
              },
              
              // Pagination
              pagination: {
                el: $block.find('.swiper-pagination')[0],
                clickable: true
              },
              
              // Important for mobile: watch for parent container changes
              observer: true,
              observeParents: true,
              
              on: {
                beforeInit: function() {
                  console.log('Swiper before init with fixed width:', containerWidth);
                },
                
                init: function() {
                  console.log('Swiper initialized');
                  
                  // Once fully initialized, remove the initializing class and show the swiper
                  $swiperContainer.removeClass('swiper-container-initializing');
                  
                  // Handle navigation visibility
                  if (this.isBeginning) {
                    $block.find('.swiper-button-prev').hide();
                  }
                  if (this.isEnd) {
                    $block.find('.swiper-button-next').hide();
                  }
                  
                  // Manually update swiper to ensure correct dimensions
                  this.update();
                },
                
                resize: function() {
                  // Update container width on resize
                  const newWidth = $swiperContainer.parent().width();
                  $swiperContainer.css('width', newWidth + 'px');
                  this.update();
                },
                
                slideChange: function() {
                  // Show/hide prev button
                  if (this.isBeginning) {
                    $block.find('.swiper-button-prev').hide();
                  } else {
                    $block.find('.swiper-button-prev').show();
                  }
                  // Show/hide next button
                  if (this.isEnd) {
                    $block.find('.swiper-button-next').hide();
                  } else {
                    $block.find('.swiper-button-next').show();
                  }
                }
              }
            });
          }
        }
      });
    }, 100); // Small delay to ensure DOM is ready
  
    /**
     * Open content in a Side panel
     */
    const $triggers = $blocks.find('[data-hs-overlay]');
    $triggers.on('click', function(e) {
      e.preventDefault();
      const overlayId = $(this).data('hs-overlay');
      // Set overflow hidden on html element
      $('html').css('overflowY', 'hidden');
      // Listen for click on close button and overlay background to restore scroll
      const $overlay = $(overlayId);
      const $closeButton = $overlay.find('button[data-hs-overlay]');
      $closeButton.one('click', function() {
        $('html').css('overflowY', 'auto');
      });
      // Listen for click on overlay to restore scroll (clicks on children is not considered a close event)
      $overlay.on('click', function(e) {
        if (e.target === this) {
          $('html').css('overflowY', 'auto');
          // Remove this event listener after it's triggered
          $(this).off('click');
        }
      });
    });
    
    // Handle Escape key to close overlay and restore scroll
    $(document).on('keyup', function(e) {
      if (e.key === 'Escape') {
        $('html').css('overflowY', 'auto');
      }
    });
  });